var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center","height":"100vh","display":"flex","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"max-width":"100%","max-height":"100%","width":"auto","height":"auto"},attrs:{"src":"/welcome_img.png","alt":"Welcome"}})])])
}]

export { render, staticRenderFns }